
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import sv from '@drawbotics/drylus-style-vars';
import {
  Table,
  Panel,
  PanelBody,
  PanelSection,
} from '@drawbotics/react-drylus';
import InlineCode from '~/components/InlineCode';
export const Constants = () => {
  const data = Object.keys(sv).map(key => ({
    name: key,
    value: <InlineCode mdxType="InlineCode">{String(sv[key])}</InlineCode>
  }));
  return <div style={{
    overflow: 'scroll'
  }}>
      <Table data={data} header={['name', 'value']} mdxType="Table" />
    </div>;
};

const layoutProps = {
  Constants
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Style Variables`}</h1>
<p>{`Here is a comprehensive list of all the constants exposed by the `}<inlineCode parentName="p">{`drylus-style-vars`}</inlineCode>{` package. These are only for reference, if you're unsure what value to use for a particular style do ask our designers first.`}</p>
<p>{`All of the following (except functions) are available as CSS and LESS variables.`}</p>

<Constants mdxType="Constants" />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;